import { render, staticRenderFns } from "./GoogleResetBind.vue?vue&type=template&id=980782d0&"
import script from "./GoogleResetBind.vue?vue&type=script&lang=js&"
export * from "./GoogleResetBind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports